export const PageRoute = {
  Pedidos: '/pedidos'
}
